import type { GriddCell, GriddDocument } from "@/types/document";

// A valid blank Gridd document (TODO §5.3). Gridd's own default is an empty 0×0 grid,
// which isn't usable; this mirrors welcome.json's shape — the template the app loads
// for first-time users — so the save contract's keys all match.
//
// Never reuse welcome.json's cell ids: cellStyles keys off the cell UUID, so every
// cell must get a fresh crypto.randomUUID(). We seed with empty cellStyles, so there
// are no keys to collide, but the fresh-id rule holds regardless.

// An empty ProseMirror paragraph doc — the content of a blank cell. Exported so the
// library-copy adapter (§8.5) can fill a cell that arrives without a usable `json`.
export function emptyCellJson(): unknown {
  return {
    type: "doc",
    content: [{ type: "paragraph", attrs: { textAlign: null }, content: [] }],
  };
}

function makeCell(): GriddCell {
  return { id: crypto.randomUUID(), text: "", json: emptyCellJson() };
}

// A 2×2 grid of equal-weight rows/cols with empty cells.
export function seedGriddDocument(): GriddDocument {
  return {
    cols: [1, 1],
    rows: [1, 1],
    cells: [
      [makeCell(), makeCell()],
      [makeCell(), makeCell()],
    ],
    cellStyles: {},
    borders: [],
    merged: [],
  };
}
